<input type="checkbox" [(ngModel)]="showNotAssigned"><small>&ensp;Mostra prodotti non più assegnati al cliente</small>

<div class="row">
    <div class="col-2">
        <small>
            <ul class="card small-box list-group p-1 d-none d-lg-block mt-2 mb-4" *ngIf="type_product">
                <li class="list-group-item pointer" [class.active]="filter_id_type.value==''" (click)="filter_id_type.value='';getItems()">Tutte le tipologie</li>
                <li *ngFor="let i of type_product" class="list-group-item pointer"  [class.active]="checkFilterTypeValue('filter_id_type',i.id)" (click)="setFilterTypeValue('filter_id_type',i.id);getItems()">{{i.name}}</li>
                <div *ngIf="type_product.length>2" class="icon"><i class="fas fa-stream"></i></div>
            </ul>
        </small>

    </div>
    <div class="col-10">
        <table class="table table-sm table-stripped">
            <thead>
                <th>Modello</th>
                <th>Tipologia</th>
                <th>Numero Seriale</th>
                <th>Ubicazione</th>
                <th></th>
            </thead>
            <tbody>
                <ng-container *ngFor="let record of list">
                <tr *ngIf="isShow(record)">
                    <td>
                        <small class="text-info" style="color:{{record.categorycolor}} !important;"><i *ngIf="record.icon" class="{{record.icon}}"></i> <i *ngIf="!record.icon" class="fa fa-cash-register"></i> {{record.category}}</small><br/>
                        <h6> &nbsp;{{record.brand}} {{record.model}}
                            <div class="badge badge-warning" *ngIf="id_shop!=record.current_id_shop && id_address!=record.current_id_address">
                                <i class="fa fa-exclamation"></i>&nbsp;Non più assegnato a questo cliente
                            </div>
                        </h6>
                    </td>
                    <td class="text-center">
                        {{record.type}}
                    </td>
                    <td class="text-center">
                        <b>{{record.sn}}</b><span *ngIf="record.matricola"><br/> {{ record.matricola }}</span>
                    </td>
                    <td>
                        <small><i class="fa fa-store"></i>&nbsp; {{record.shopname}}</small>
                    </td>
                    <td>
                        <button type="button" *ngIf="mode!='modal'" (click)="openDetail(record)"  title="Modifica / Vedi" class="btn btn-secondary btn-xs float-right m-1">
                                <i class="fas fa-pencil-alt"></i></button>
                    </td>
                </tr>
                </ng-container>
            </tbody>

        </table>
        <!--
        <ul class="list-group">
            <ng-container *ngFor="let record of list">
                <li class="list-group-item border-bottom"  *ngIf="isShow(record)">

                    <div class="row">
                        <div class="col-md-10">
                            <small class="text-info">{{record.category}}</small><br/>
                            <h6><i *ngIf="record.icon" class="{{record.icon}}"></i> <i *ngIf="!record.icon" class="fa fa-cash-register"></i> &nbsp;{{record.brand}} {{record.model}} ({{record.type}}) 
                                <div class="badge badge-warning" *ngIf="id_shop!=record.current_id_shop && id_address!=record.current_id_address">
                                    <i class="fa fa-exclamation"></i>&nbsp;Non più assegnato a questo cliente
                                </div>
                            </h6>
                            <b>{{record.sn}}</b><span *ngIf="record.matricola"> / {{ record.matricola }}</span><br/>
                            <small><i class="fa fa-store"></i>&nbsp; {{record.shopname}}</small>
                            
                        </div>
                        <div class="col-md-2">
                            <button type="button" *ngIf="mode!='modal'" (click)="openDetail(record)"  title="Modifica / Vedi" class="btn btn-secondary btn-xs float-right m-1">
                                <i class="fas fa-pencil-alt"></i></button>
                        </div>
                    </div>
                </li>
            </ng-container> 
        </ul>
        -->
    </div>
</div>

<div class="row mt-2">
    <div class="col-12">
        <button class="btn btn-sm btn-success" (click)="addInstallation()"><i class="fa fa-plus"></i>&nbsp;Aggiungi prodotto</button>
    </div>
</div>